<script>
import { mapState } from 'vuex'
import PlanCard from './PlanCard.vue'
export default {
  name: 'PlanCards',
  props: ['alt'], // 'alt' is alternate version w/o enroll button
  components: {
    PlanCard,
  },
  computed: {
    ...mapState(['plans']),
    orderedPlans() {
      const p = [...this.plans]
      return p.sort((a, b) => +a.costPerMonth - +b.costPerMonth)
    },
  },
}
</script>

<template>
  <v-container fluid id="memberships" class="section ma-auto pa-0 px-2" :class="[alt ? 'memberships-alt' : 'memberships']">
    <v-row>
      <v-col>
        <v-container class="inset">
          <v-row>
            <v-col>
              <h2 v-if="!alt" class="mb-6 mt-2">Enroll today and save</h2>
              <v-row justify="center" class="text-left" :class="[alt ? 'memberships-alt' : 'memberships']">
                <v-col v-for="plan in orderedPlans" :key="plan.id" class="mb-12 d-flex flex-column" md="4" cols="12">
                  <PlanCard :alt="alt" :plan="plan" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
  .memberships {
    background-color: $hpp-blue;
  }
  .memberships h2 {
    color: white;
    font-weight: 400;
  }
  .memberships-alt {

  }
  .memberships-alt h2 {
    color: $hpp-blue;
    font-weight: 400;
  }
  .subtext {
    color: white;
  }
  .section {
    min-height: 400px;
    margin: 50px auto;
  }
  .section h2 {
    margin-bottom: 20px;
  }
  .section p {
    margin-bottom: 40px;
  }

</style>
